import { CSSProperties, FC } from 'react';
import { Root } from './style';

import { FontSize, FontWeight, GeneralColors, Radius, Screen } from '../../../theme';

export interface ButtonProps {
  children: React.ReactNode;
  size?: FontSize;
  weight?: FontWeight;
  disabled?: boolean;
  radius?: Radius;
  text?: boolean;
  ghost?: boolean;
  fullWidth?: boolean;
  color?: GeneralColors;
  textColor?: GeneralColors;
  inline?: boolean;
  shadow?: boolean;
  justify?: 'left' | 'center' | 'right';
  [x: string]: any;
  fullWidthBreakpoint?: Screen;
}

const Button: FC<ButtonProps> = ({ children, shadow = true, justify, style, ...otherProps }) => {
  // Not a fan of this and missing Tailwind a lot.
  let finalStyle: CSSProperties = { ...style };
  if (justify) {
    let margin: { margin?: string; marginLeft?: string; marginRight?: string } = { margin: 'auto' };
    if (justify === 'right') margin = { marginLeft: 'auto' };
    if (justify === 'left') margin = { marginRight: 'auto' };
    finalStyle = { ...style, ...margin };
  }
  return (
    <Root shadow={shadow} style={finalStyle} {...otherProps}>
      {children}
    </Root>
  );
};

export default Button;
